export const API_KEY = '9847742e-2fc3-415a-bfd5-3211724c6697';
export const SOCKET_SITE_PATH = '/v2/socket';
export const API_BASE_URL = 'https://api.squarerisk.com/v2/';
export const SOCKET_BASE_URL = 'wss://api.squarerisk.com';
export const S3_BUCKET_NAME = 'square-risk-files';
export const S3_BUCKET_REGION = 'us-east-1';
export const S3_BUCKET_COMPANY_LOGO_PATH = 'company/logo';
export const S3_BUCKET_COMPANY_FILE_PATH = 'company-product/policies';
export const S3_BUCKET_COMPANY_DOCUMENTS_PATH = 'company/documents';
export const S3_BUCKET_FILE = 'pre-signature-templates';
export const STRIPE_API_KEY =
  'pk_live_51N0THhAI6Ki5Yiqevdwkud6YlxgSuHWyzRXXQl9uSufFeWus2X7RVPaFHBaWTnvF6ZFkn8QFcTXFey2tm2kjBY7800BTU6tUzU';
export const AGENT_PANEL_BASE_URL = 'https://app.squarerisk.com';
export const ZOHO_CHAT_KEY = 'siq5154518ba68248cc63ab567ee4fcd83fa3b035fc9bf68dbf7643a796b8ea5bab';
export const GOOGLE_API_KEY = 'AIzaSyCdRRH43THUGAVQ83hyI15F1C1vjB0WrRs';
export const MICROSOFT_API_KEY = '371ee54b-f937-e1a3-b3c6-a827bda37e03';